import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const NUMBER = "918000151777";
const MESSAGE =
  "Hello Rahil Engineering Works, I would like a quotation for fasteners. Details:";

const HIDDEN = { opacity: 0, y: 24, scale: 0.9 };
const VISIBLE = { opacity: 1, y: 0, scale: 1 };
const SPRING = { duration: 0.4, ease: [0.16, 1, 0.3, 1] };

export default function WhatsAppButton() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 420);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.a
          href={`https://wa.me/${NUMBER}?text=${encodeURIComponent(MESSAGE)}`}
          target="_blank"
          rel="noreferrer"
          aria-label="Enquire on WhatsApp"
          data-testid="whatsapp-float-btn"
          initial={HIDDEN}
          animate={VISIBLE}
          exit={HIDDEN}
          transition={SPRING}
          className="group fixed z-[90] bottom-6 right-5 sm:bottom-8 sm:right-8 flex items-center gap-0 hover:gap-3 rounded-full bg-[#1FA855] text-white shadow-[0_10px_30px_rgba(31,168,85,0.35)] pl-[15px] pr-[15px] hover:pr-6 py-[15px] transition-all duration-300 hover:shadow-[0_14px_38px_rgba(31,168,85,0.45)]"
        >
          <span className="absolute inset-0 rounded-full bg-[#1FA855]/40 animate-ping-slow pointer-events-none" />
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="relative shrink-0">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.347-.347.52-.52.174-.174.232-.298.347-.497.116-.198.058-.371-.028-.52-.087-.148-.669-1.611-.916-2.206-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347Z" />
            <path d="M20.52 3.449A11.86 11.86 0 0 0 12.05 0C5.495 0 .16 5.334.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.305-1.654a11.86 11.86 0 0 0 5.74 1.464h.005c6.554 0 11.89-5.335 11.892-11.893a11.82 11.82 0 0 0-3.422-8.468ZM12.05 21.786h-.004a9.87 9.87 0 0 1-5.03-1.378l-.36-.214-3.742.982.999-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.262c.002-5.45 4.436-9.884 9.888-9.884a9.82 9.82 0 0 1 6.988 2.898 9.83 9.83 0 0 1 2.892 6.994c-.003 5.451-4.437 9.886-9.886 9.886Z" />
          </svg>
          <span className="relative max-w-0 group-hover:max-w-[190px] overflow-hidden whitespace-nowrap text-[11px] tracking-[0.14em] uppercase font-bold transition-all duration-300">
            Enquire on WhatsApp
          </span>
        </motion.a>
      )}
    </AnimatePresence>
  );
}
